import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from './components/Sidebar';
import ListItems from './containers/ListItems';
import Footer from './components/Footer';
import NoticeModal from './components/NoticeModal';
const { detect } = require('detect-browser');

async function loadItems() {
  const indexResponse = await axios.get('/static/items/index.json');
  const itemResponses = await Promise.all(
    indexResponse.data.items.map((item) => axios.get(item.file))
  );
  return itemResponses.map((response) => response.data);
}

async function loadNoticeModal() {
  try {
    const response = await axios.get('/static/notice-modal.json');
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
}

function parseOptionalDate(value) {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function shouldShowNoticeModal(config) {
  if (!config || !config.enabled) {
    return false;
  }

  const startAt = parseOptionalDate(config.startAt);
  const endAt = parseOptionalDate(config.endAt);
  const now = new Date();
  const button = config.button || {};

  if (config.startAt && !startAt) {
    return false;
  }

  if (config.endAt && !endAt) {
    return false;
  }

  if (startAt && now < startAt) {
    return false;
  }

  if (endAt && now > endAt) {
    return false;
  }

  return Boolean(config.title && config.content && button.label && button.url);
}

export default function SnirhApp() {
  const [items, setItems] = useState([]);
  const [noticeModal, setNoticeModal] = useState(null);
  const [viewport, setViewport] = useState('');

  function handleResize() {
    const wWidth = window.innerWidth;

    if (wWidth < 1024) {
      setViewport('smartphone');
    } else if (wWidth >= 1024 && wWidth <= 1279) {
      setViewport('tablet');
    } else {
      setViewport('desktop');
    }
  }

  useEffect(() => {
    const browser = detect();
    document.documentElement.classList.add(browser.name);

    handleResize();

    let mounted = true;

    Promise.all([loadItems(), loadNoticeModal()])
      .then(([itemsData, noticeModalData]) => {
        if (!mounted) {
          return;
        }

        setItems(itemsData);
        setNoticeModal(shouldShowNoticeModal(noticeModalData) ? noticeModalData : null);
      })
      .catch((error) => {
        console.error('Erro ao carregar os conteudos do portal.', error);
      });

    window.addEventListener('resize', handleResize);
    return () => {
      mounted = false;
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Sidebar viewport={viewport} />
      <ListItems items={items} viewport={viewport} />
      {viewport === 'smartphone' && <Footer viewport={viewport} />}
      {noticeModal && <NoticeModal config={noticeModal} onClose={() => setNoticeModal(null)} />}
    </>
  );
}
